export default __webpack_public_path__ + "static/media/logo-ocre-blanc.694db58a.png";